import { saveAs } from 'file-saver'
import $http from '@/libs/axios'

export default class CustomerReviewsAPI {
  static async updateVisibility(params: { id: number; is_shown_in_webapp: number; branch_id: number }) {
    const response = await $http.post('/customer-reviews/update', {
      id: params.id,
      is_shown_in_webapp: params.is_shown_in_webapp,
      branch_id: params.branch_id,
    })
    return response.data
  }

  static async getSettings(branchId: number) {
    return (await $http.get(`/customer-reviews/settings/${branchId}`)).data
  }

  static async export(branchId: number, options: any = {}) {
    const queryParams = new URLSearchParams()
    if (options.from_date) {
      queryParams.append('filter[fromDate]', options.from_date)
    }
    if (options.to_date) {
      queryParams.append('filter[toDate]', options.to_date)
    }
    const query = queryParams.toString()
    const file = (await $http.get(`/customer-reviews/export?${query}`, { responseType: 'blob' })).data
    const from = options.from_date !== '' ? `--from=${options.from_date}` : ''
    const to = options.to_date !== '' ? `--to=${options.to_date}` : ''
    const name = `${from}${to}`
    saveAs(file, `customer-reviews${name}.xlsx`)
    return file
  }
}
